import { ApolloError } from '@apollo/client'
import { useErrorHandler } from 'components/error'
import { useGerarLinkSistemaExternoMutation } from 'graphql/hooks.generated'
import { useCallback, useEffect, useState } from 'react'

export interface SistemaExterno {
  id: string
  providerId: string
  nome: string
}

export function useLinkSistemaExterno(sistemaExterno: SistemaExterno | null, cidadaoId?: ID) {
  const [url, setUrl] = useState('')
  const handleError = useErrorHandler()
  const [gerarLink, { loading }] = useGerarLinkSistemaExternoMutation()

  const refresh = useCallback(async () => {
    if (!sistemaExterno) {
      setUrl('')
      return
    }
    try {
      const { data } = await gerarLink({
        variables: {
          input: {
            providerId: sistemaExterno.providerId,
            sistemaExternoId: sistemaExterno.id,
            cidadaoId,
          },
        },
      })
      setUrl(data?.gerarLinkSistemaExterno ?? '')
    } catch (e) {
      handleError(e as ApolloError)
    }
  }, [sistemaExterno, cidadaoId, gerarLink, handleError])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { url, refresh, loading }
}
